import styled, { keyframes } from "styled-components";

const LoadingAnimation = keyframes`  
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  float: left;

  span {
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    svg {
      animation-name: ${LoadingAnimation};
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-direction: normal;
    }
    
  }
  
`;

